import { ReactNode } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { useTranslation } from "shared/localization/localization";
import styles from "./ErrorBoundary.module.scss";

const DefaultFallback: RFC = () => {
  const { t } = useTranslation();
  return <div className={styles.fallback}>{t("Something went wrong. Please try again later.")}</div>;
};

export const ErrorBoundary: RFC<{ fallback?: ReactNode }> = ({ children, fallback }) => {
  return (
    <ReactErrorBoundary fallbackRender={() => <>{fallback ?? <DefaultFallback />}</>}>{children}</ReactErrorBoundary>
  );
};

ErrorBoundary.displayName = ErrorBoundary.name;
